import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import { colors } from "../../theme/colors";
import MMSegmentedControl from "./MMSegmentedControl";
import { snapFigure } from "./mmPreferenceSegments";
import { MOBILE_NAV_MQ } from "./lobbySettingsStyles";

export default function MMPreferenceSegmentRow({
    setting,
    onFigureChange,
    disabled = false,
}) {
    const selectedValue = snapFigure(
        setting.figure,
        setting.options,
        setting.figure,
    );

    return (
        <Box
            sx={{
                py: "0.85rem",
                borderTop: `1px solid ${colors.border.subtle}`,
                opacity: disabled ? 0.55 : 1,
                pointerEvents: disabled ? "none" : "auto",
            }}
        >
            <Typography
                sx={{
                    color: colors.text.primary,
                    fontSize: "0.9rem",
                    fontWeight: 600,
                    lineHeight: 1.3,
                    minWidth: 0,
                }}
            >
                {setting.title}
            </Typography>
            <Box
                sx={{
                    mt: "0.7rem",
                    width: "100%",
                    [MOBILE_NAV_MQ]: {
                        mt: "0.55rem",
                    },
                }}
            >
                <MMSegmentedControl
                    options={setting.options}
                    value={selectedValue}
                    disabled={disabled}
                    ariaLabel={setting.title}
                    onChange={(nextValue) => onFigureChange(setting.id, nextValue)}
                />
            </Box>
        </Box>
    );
}

MMPreferenceSegmentRow.propTypes = {
    setting: PropTypes.shape({
        id: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        figure: PropTypes.number,
        options: PropTypes.arrayOf(
            PropTypes.shape({
                value: PropTypes.number.isRequired,
                label: PropTypes.string.isRequired,
            }),
        ),
    }).isRequired,
    onFigureChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool,
};
